import React from 'react';
import { Box, Typography, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const PageHeader = ({ title, breadcrumbs = [], children }) => {
  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbs.length > 0 && (
        <Breadcrumbs
          separator={<NavigateNextIcon sx={{ fontSize: 16, color: '#BDC1C6' }} />}
          sx={{ mb: 0.5 }}
        >
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return isLast ? (
              <Typography key={index} sx={{ fontSize: '0.8125rem', color: '#5F6368', fontWeight: 400 }}>
                {crumb.label}
              </Typography>
            ) : (
              <MuiLink
                key={index}
                component={RouterLink}
                to={crumb.link}
                underline="hover"
                sx={{ fontSize: '0.8125rem', color: '#1A73E8', fontWeight: 400 }}
              >
                {crumb.label}
              </MuiLink>
            );
          })}
        </Breadcrumbs>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 400,
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
            color: '#202124',
          }}
        >
          {title}
        </Typography>
        {children && (
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {children}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PageHeader;
